import { useMemo } from 'react';
import { Card, StatTile } from '../../../../components/ui/Card';
import { useBrandReport } from '../../../../hooks/useVisibility';
import { useFilters, shiftDate } from '../filters';
import { extractOwn, pct, score, pos, deltaProps } from '../format';
import { LoadingState } from '../../../../components/ui/States';

export function KpiRow() {
  const { startDate, endDate } = useFilters();
  const { data, isLoading } = useBrandReport(startDate, endDate, { order_by: 'visibility' });

  const windowDays = Math.max(
    1,
    Math.round((new Date(endDate).getTime() - new Date(startDate).getTime()) / 86_400_000) + 1,
  );
  const prevEnd = shiftDate(startDate, -1);
  const prevStart = shiftDate(prevEnd, -(windowDays - 1));
  const { data: prevData } = useBrandReport(prevStart, prevEnd, { order_by: 'visibility' });

  const own = useMemo(() => extractOwn(data), [data]);
  const prevOwn = useMemo(() => extractOwn(prevData), [prevData]);

  if (isLoading) {
    return <Card padding="lg"><LoadingState /></Card>;
  }

  if (!own) {
    return (
      <Card padding="lg">
        <p className="text-body-sm text-text-tertiary">
          No visibility data yet — run a citation sweep to populate.
        </p>
      </Card>
    );
  }

  const dVis = deltaProps(own.visibility, prevOwn?.visibility ?? null, { suffix: 'pt' });
  const dSov = deltaProps(own.shareOfVoice, prevOwn?.shareOfVoice ?? null, { suffix: 'pt' });
  const dSent = deltaProps(own.sentiment, prevOwn?.sentiment ?? null);
  const dPos = deltaProps(own.position, prevOwn?.position ?? null, { lowerIsBetter: true });

  return (
    <div className="grid gap-4 grid-cols-2 lg:grid-cols-4">
      <StatTile label="Visibility" value={pct(own.visibility)} {...(dVis ? { change: dVis } : {})} />
      <StatTile label="Share of voice" value={pct(own.shareOfVoice)} {...(dSov ? { change: dSov } : {})} />
      <StatTile label="Sentiment" value={score(own.sentiment)} {...(dSent ? { change: dSent } : {})} />
      <StatTile label="Avg position" value={pos(own.position)} {...(dPos ? { change: dPos } : {})} />
    </div>
  );
}
